angular.module('limousineModule', ['limousineTemplates']);
